import { useRef, useState } from 'react'
import { CognitoUnauthorizedError } from './useCognitoUserIsAuthenticated'

export const usePasswordVerificationTray = () => {
  const [isPasswordTrayOpen, setIsPasswordTrayOpen] = useState(false)
  const onAuthenticationComplete = useRef<(() => void) | (() => Promise<void>) | undefined>()

  function openVerifyPasswordTray(callback: () => void) {
    setIsPasswordTrayOpen(true)
    onAuthenticationComplete.current = callback
  }

  function closeVerifyPasswordTray() {
    setIsPasswordTrayOpen(false)
    onAuthenticationComplete.current = undefined
  }

  function handleCognitoError(error: unknown, retryCallback: () => void | Promise<void>) {
    if (error instanceof CognitoUnauthorizedError) {
      // onVerify(mfaMethod) save to .current ref
      openVerifyPasswordTray(retryCallback)
      return true
    }
    return false
  }

  function handleVerify() {
    const fn = onAuthenticationComplete.current
    closeVerifyPasswordTray()
    fn && fn()
  }

  return {
    isPasswordTrayOpen,
    openVerifyPasswordTray,
    closeVerifyPasswordTray,
    handleCognitoError,
    handleVerify,
  }
}
